import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";
import "../Styles/login.css";

const AdminLogin = () => {
  // "login" = Login page, "forgot" = Forgot Password page
  const [view, setView] = useState("login");

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const [forgotEmail, setForgotEmail] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const [message, setMessage] = useState("");

  const [forgotMessage, setForgotMessage] = useState("");
  const [forgotMessageType, setForgotMessageType] = useState(""); // "success" | "error"
  const [forgotLoading, setForgotLoading] = useState(false);

  const navigate = useNavigate();

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ── Login ──────────────────────────────────────────────────────────────────
  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const res = await axios.post(`${API_BASE_URL}/api/auth/login`, {
        email: loginData.email,
        password: loginData.password,
      });

      setMessage(res.data.message || "Login successful");

      if (res.data.token) {
        localStorage.setItem("adminToken", res.data.token);
        sessionStorage.setItem("adminToken", res.data.token);
        if (res.data.name) {
          localStorage.setItem("userName", res.data.name);
          sessionStorage.setItem("userName", res.data.name);
        }
        if (res.data.email) {
          localStorage.setItem("userEmail", res.data.email);
          sessionStorage.setItem("userEmail", res.data.email);
        }
        navigate("/admin/dashboard");
      }
    } catch (error) {
      setMessage(
        error.response?.data?.message ||
          error.response?.data?.msg ||
          "Login failed"
      );
    }
  };

  // ── Forgot Password ────────────────────────────────────────────────────────
  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    setForgotLoading(true);
    setForgotMessage("");

    try {
      const res = await axios.post(`${API_BASE_URL}/api/auth/forgot-password`, {
        username: forgotEmail,
      });
      setForgotMessage(res.data.message || "Reset link sent!");
      setForgotMessageType("success");
    } catch (error) {
      setForgotMessage(
        error.response?.data?.msg ||
          error.response?.data?.message ||
          "Something went wrong"
      );
      setForgotMessageType("error");
    } finally {
      setForgotLoading(false);
    }
  };

  return (
    <div className="adminlogin-container">
      {/* ---------------- LEFT SIDE ---------------- */}
      <div className="adminlogin-left">
       <div className="adminlogin-logo">
          <img
            src="/tm.png"
            alt="Outstanding Logo"
            className="adminlogin-logo-img"
          />
        </div>

       <div className="adminlogin-illustration">
        <img src="/Admin_login_img.png" alt="Outstanding" />
      </div>
        <div className="adminlogin-left-bottom">
          <h2>Welcome Back!</h2>
          <p>Sign in to your Customer account</p>
        </div>
      </div>

      {/* ---------------- RIGHT SIDE ---------------- */}
      <div className="adminlogin-right">
        {view === "login" ? (
          <form className="adminlogin-form" onSubmit={handleLoginSubmit}>
            <h1 className="adminform-heading">Admin Login</h1>

            <p className="adminform-subheading">
              Enter your credentials to access the admin dashboard
            </p>

            <label className="adminform-label">User Email ID</label>

            <input
              type="text"
              name="email"
              className="adminform-input"
              placeholder="Enter your Email ID"
              value={loginData.email}
              onChange={handleLoginChange}
              required
            />

            <label className="adminform-label">Password</label>

            <div className="adminpassword-field">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="adminform-input"
                placeholder="Enter your Password"
                value={loginData.password}
                onChange={handleLoginChange}
                required
              />
             <img 
  src={showPassword ? "/ey_2.png" : "/Admin_log_eye.png"}
  alt={showPassword ? "Hide password" : "Show password"}
  className="adminpassword-eye-icon"
  onClick={() => setShowPassword((prev) => !prev)}
/>
            </div>

            <button
              type="button"
              className="adminlink-btn adminforgot-link"
              onClick={() => {
                setView("forgot");
                setForgotMessage("");
              }}
            >
              Forgot Password?
            </button>

            <button type="submit" className="adminprimary-btn">
              SIGN IN
            </button>

            {message && (
              <p
                className="login-message"
                style={{
                  color: message === "Login successful" ? "green" : "red",
                  marginTop: "12px",
                }}
              >
                {message}
              </p>
            )}
          </form>
        ) : (
          <form className="adminlogin-form" onSubmit={handleForgotSubmit}>
            <h1 className="adminform-heading">Forgot Password?</h1>

            <p className="adminform-subheading">
              Enter your username and we'll send a reset link to the registered
              email.
            </p>

            <label className="adminform-label">User Email ID</label>

            <input
              type="text"
              name="forgotEmail"
              className="adminform-input"
              placeholder="Enter your Email ID"
              value={forgotEmail}
              onChange={(e) => setForgotEmail(e.target.value)}
              required
            />

            {forgotMessage && (
              <p
                className="forgot-message"
                style={{
                  color: forgotMessageType === "success" ? "#16a34a" : "#dc2626",
                  fontSize: "13px",
                  marginBottom: "12px",
                }}
              >
                {forgotMessage}
              </p>
            )}

            <button
              type="button"
              className="adminlink-btn adminback-link"
              onClick={() => {
                setView("login");
                setForgotMessage("");
              }}
            >
              <div className="adminback-link-content">
                        <img
              src="/Admin_log-arrow.png"
              alt="Back"
              className="adminback-arrow"
            />
            <span>Back to Login</span>
            </div>
            </button>

            <button
              type="submit"
              className="adminprimary-btn"
              disabled={forgotLoading}
              style={{ opacity: forgotLoading ? 0.7 : 1 }}
            >
              {forgotLoading ? "Sending..." : "Send Reset Link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default AdminLogin;